export const LANDING_PAGE_IMAGES_BUCKET = 'landing-page-images';

const PUBLIC_MARKERS = [
  `/object/public/${LANDING_PAGE_IMAGES_BUCKET}/`,
  `/render/image/public/${LANDING_PAGE_IMAGES_BUCKET}/`,
];

export function landingStorageObjectPathFromUrl(url: string): string | null {
  const raw = url.trim();
  if (!raw) return null;
  for (const marker of PUBLIC_MARKERS) {
    const i = raw.indexOf(marker);
    if (i === -1) continue;
    const rest = raw.slice(i + marker.length).split('?')[0]?.split('#')[0] ?? '';
    if (!rest) return null;
    try {
      return decodeURIComponent(rest);
    } catch {
      return rest;
    }
  }
  return null;
}

export function addLandingStoragePath(
  out: Set<string>,
  path?: string | null,
  url?: string | null
): void {
  const direct = typeof path === 'string' ? path.trim() : '';
  if (direct) out.add(direct);
  if (typeof url === 'string') {
    const fromUrl = landingStorageObjectPathFromUrl(url);
    if (fromUrl) out.add(fromUrl);
  }
}

/** intro content_json·layout_json 안에 남은 landing-page-images 참조를 모은다. */
export function collectLandingStoragePathsFromUnknown(value: unknown, out: Set<string>): void {
  if (value == null) return;
  if (typeof value === 'string') {
    addLandingStoragePath(out, null, value);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item) => collectLandingStoragePathsFromUnknown(item, out));
    return;
  }
  if (typeof value !== 'object') return;
  const o = value as Record<string, unknown>;
  if (typeof o.path === 'string' || typeof o.url === 'string') {
    addLandingStoragePath(
      out,
      typeof o.path === 'string' ? o.path : null,
      typeof o.url === 'string' ? o.url : null
    );
  }
  for (const child of Object.values(o)) {
    collectLandingStoragePathsFromUnknown(child, out);
  }
}

export function diffOrphanLandingStorageNames(
  stored: string[],
  referenced: Iterable<string>
): string[] {
  const keep = new Set(
    Array.from(referenced)
      .map((p) => p.trim())
      .filter(Boolean)
      .map((p) => p.replace(/^\//, ''))
  );
  return stored.filter((name) => {
    const n = name.replace(/^\//, '');
    return Boolean(n) && !keep.has(n);
  });
}
